module.exports = __webpack_public_path__ + "img/left_md_1.123ee676.jpg";